<template>
    <div class="index">
        <div class="flash">
            <div class="gg">
                <div><div class="topNav">解决方案</div></div>
                <div class="title">新能源行业</div>
                <div class="minTitle">投资决策模型数字化平台、全生命周期管理云平台</div>
                <!-- <div class="button">咨询详情</div> -->
            </div>
        </div>
        <picture>
            <source srcset="@/assets/images/xny1_mb.jpg" media="(max-width:768px)" alt="">
            <img class="flashImg" src="@/assets/images/xny1.png" />
        </picture>
       <div class="lxwm2 bg1">
            <div class="content">
                <div class="title1 tc">投资决策模型数字化平台</div>
                <div class="tc">
                    <div class="myTitle">用途：项目投资决策模型数字化平台为项目可行性评估和投资决策提供了重要依据</div>
                </div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny3.png" />
                            <div class="lb">
                                在线评估
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">平台提供了“工具”+“数据库”两种测算方式，实现投资项目的实时在线评估，数据分析与图表的导出</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny4.png" />
                            <div class="lb">
                                提升效率
                            </div>
                        </div>
                       
                        <div class="minTitle2 mt10">平台提供了移动测算和系统精算两个测算版本，提高市场人员与后台部门的工作效率</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/xny5.png" />
                            <div class="lb">
                                提升管理
                            </div>
                        </div>
                       
                        <div class="minTitle2 mt10">平台完善了项目级和企业级数据库，提升公司大数据管理水平</div>
                    </div>
                    <div class="item2 ">
                        <div class="tit">
                            <img src="@/assets/images/xny6.png" />
                            <div class="lb">
                                提升投资效能
                            </div>
                        </div>
                        <div class="minTitle2 mt10">平台提供了强大的计算能力，通过多因子敏感性分析，提升了投资效能</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny7.png" />
                            <div class="lb">
                                提升投资精准度
                            </div>
                        </div>
                        <div class="minTitle2 mt10">平台引入了生产数据等实际指标，极大提升了项目投资决策测算精准度和合理性</div>
                    </div>
                    
                </div>
            </div>
       </div>
       <div class="lxwm2 bg3">
            <div class="content">
                <div class="title1 tc">全生命周期管理云平台</div>
                <div class="tc">
                    <div class="myTitle">用途：更好地管理多业态的项目群，及时了解项目群投资、建设、运营和经营状况，完善项目的过程管控和后评估机制</div>
                </div>
                <div class="items mt5">
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny8.png" />
                            <div class="lb">
                                信息共享公用
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">平台提供了“工具”+“数据库”两种测算方式，实现投资项目的实时在线评估，数据分析与图表的导出</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny9.png" />
                            <div class="lb">
                                平台化
                            </div>
                        </div>
                        
                        <div class="minTitle2 mt10">平台提供了移动测算和系统精算两个测算版本，提高市场人员与后台部门的工作效率</div>
                    </div>
                    <div class="item2 item3">
                        <div class="tit">
                            <img src="@/assets/images/xny10.png" />
                            <div class="lb">
                                实时指标监控
                            </div>
                        </div>
                        <div class="minTitle2 mt10">平台完善了项目级和企业级数据库，提升公司大数据管理水平</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny11.png" />
                            <div class="lb">
                                专业指导
                            </div>
                        </div>
                       
                        <div class="minTitle2 mt10">平台提供了“工具”+“数据库”两种测算方式，实现投资项目的实时在线评估，数据分析与图表的导出</div>
                    </div>
                    <div class="item2">
                        <div class="tit">
                            <img src="@/assets/images/xny12.png" />
                            <div class="lb">
                                大数据
                            </div>
                        </div>
                        <div class="minTitle2 mt10">平台提供了移动测算和系统精算两个测算版本，提高市场人员与后台部门的工作效率</div>
                    </div>
                </div>
            </div>
       </div>
    </div>
</template>
<script>
    export default {
        components: {
        },
        data() {
            return {
                
            }
        },
        methods: {
            
        }
    }
</script>

<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bg3 {
            background-color: #efefef;
        }
        .myTitle {
            font-size: 12px;
            color: #333333;
            text-align: center;
            margin-top: 15px;
            background: url(../../assets/images/xny2.png) no-repeat;
            background-size: auto 80%;
            background-position-y: center;
            text-indent: 15px;
            display: inline-block;
        }
        .lxwm2 {
            padding: 30px 0;
            
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                    }
                    .hs {
                        color: #333333;
                    }
                    .towLine {
                        line-height: 15px;
                        margin-top: 5px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
    .index {
        .flashImg {
            width: 100%;
            height: calc(30w);
        }
        .bttonImg {
            width: 100%;
            height: auto;
            margin-top: 30px;
        }
        .botton {
            min-height: 370px;
            background: url(../../assets/images/jr5.png) no-repeat;
            background-size: cover;
            .leftImg {
                float: left;
                width: 45%;
                img {
                    width: 530px;
                    height: 350px;
                    margin-top: 70px;
                }

            }
            .rightCon {
                float: right;
                width: 53%;
                margin-top: 20px;
                .title1 {
                    color: #ffffff;
                }
                .tab {
                    display: inline-block;
                    color: #ffffff;
                    font-size: 14px;
                    border: 1px solid #ffffff;
                    margin-right: 10px;
                    padding: 2px 10px;
                    border-radius: 20px;
                    cursor: pointer;
                }
                .tab.active:hover {
                    color: #ffffff;
                }
                .tab.active {
                    background: -webkit-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -o-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: -moz-linear-gradient(right, #6BDEFF, #3C91FF);
                    background: linear-gradient(to right,#6BDEFF, #3C91FF);
                }
                .tabM {
                    margin-top: 15px;
                    border: 2px solid #2b4b87;
                    padding: 15px;
                    .tabCon {
                        background-color: #161644;
                        padding: 15px 10px 15px 10px ;
                        min-height: 160px;
                        .titleImg {
                            width: 20px;
                            height: 20px;
                            margin-right: 7px;
                        }
                        
                        .tabTitle {
                            color: #36B9FE;
                            font-size: 14px;
                            line-height: 23px;
                            vertical-align: bottom;
                            display: inline-block;
                        }
                        .yellow {
                            color: #FADB00;
                        }
                        .tabConItems {
                            padding: 10px 0 40px 27px;
                            .minTitle2 {
                                line-height: 20px;
                            }
                            .item {
                                display: inline-block;
                                color: #ffffff;
                                background: url(../../assets/images/rpa17.png) no-repeat;
                                background-size: auto 80%;
                                background-position-y: center;
                                text-indent: 17px;
                                width: 24%;
                                margin-bottom: 5px;
                            }
                        }
                    }
                }
                    

            }
        }
        .mb_button {
            display: none;
        }
        .lxwm2 {
            padding: 30px 0;
            
            .items {
                display: flex;
                flex-wrap: wrap;
                .item2 {
                    margin-top: 20px;
                    width: 27.33%;
                    background-color: #ffffff;
                    margin-right: 3%;
                    padding: 15px 2%;
                    min-height: 110px;
                    img {
                        height: 30px;
                        margin-right: 10px;
                    }
                    .lb {
                        display: inline-block;
                        font-size: 16px;
                        font-weight: 500;
                        line-height: 35px;
                        vertical-align: bottom;
                    }
                    .minTitle2 {
                        line-height: 20px;
                        margin-top: 15px;
                    }
                    .hs {
                        color: #333333;
                    }
                    .towLine {
                        line-height: 15px;
                        margin-top: 5px;
                    }
                }
                .item3 {
                    margin-right: 0;
                    
                }
            }
        }
    }
</style>
<style lang="less" scoped>
@media (max-width: 1230px) {
  .index {
    .flash {
      position: relative;
      padding: 0 50px;
      .gg .title {
        font-size: 24px;
      }
    }
    .flashImg {
      height: 100vh;
    }
  }
}
@media (max-width: 960px) {
  .index {
    .flash {
      .gg {
        color: #fff;
        .title {
          font-size: 20px;
        }
        .minColor2 {
            color: #fff;
            border-color: #fff;
        }
        .minTitle {
          width: 100%;
          font-size: 13px;
        }
        .button {
          padding: 6px 15px;
          margin-top: 20px;
        }
      }
    }
    .lxwm2 {
        .title1 {
            margin-bottom: 0;
            margin-top: 0;
        }
        .myTitle {
            font-size: 14px;
            background: none;
        }
        .items {
            .item2 {
                width: 100%;
                margin-right: 0;
                padding: 15px 15px;
                .minTitle2 {
                    font-size: 14px;
                }
                .lb {
                    line-height: normal;
                }
                .tit {
                    display: flex;
                    align-items: center;
                    img {
                        height: 20px;
                    }
                }
            }
        }
    }
  }
}
@media (max-width: 768px) {
    .index {
        .flash {
            padding: 0 15px;
            .minTitle {
                width: 50%;
                font-size: 13px;
                color: #fff;
                margin-top: 26px;
                padding-right: 20px;
                box-sizing: border-box;
            }
            .gg {
                top: 50px;
                .title {
                    font-size: 20px;
                    margin-top: 26px;
                }
                .button {
                    padding: 6px 15px;
                    margin-top: 20px;
                }
            }
            
        }
        .flashImg {
            height: 40vh;
        }
    }
}
</style>